// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PhoneFlowDialog-trigger__nPCkI{width:var(--size-full);cursor:pointer}.PhoneFlowDialog-dialogBody___Q_ea{display:flex;flex-direction:column;gap:var(--size-4);padding:var(--size-4)}.PhoneFlowDialog-dialogBodyText__Guqjg{font:var(--font-body-400-compact);font-feature-settings:var(--feature-settings-body-400-compact);letter-spacing:var(--letter-spacing-body-400-compact);color:var(--gray-a11)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"trigger": "PhoneFlowDialog-trigger__nPCkI",
	"dialogBody": "PhoneFlowDialog-dialogBody___Q_ea",
	"dialogBodyText": "PhoneFlowDialog-dialogBodyText__Guqjg"
};
export default ___CSS_LOADER_EXPORT___;
